import Config from 'react-native-config';

export function ossImg(url, cache = false) {
  let ret = url;
  const ossOrigin = Config.APP_OSS_URL;
  if (typeof ret !== 'string') {
    return '';
  }
  if (ret.indexOf('blob') > -1) {
    return ret;
  }
  ret = ossOrigin + (ret[0] === '/' ? '' : '/') + ret;
  if (cache) {
    if (typeof cache !== 'boolean') {
      ret = ret + '?' + cache;
    } else {
      ret = ret + '?' + new Date().valueOf();
    }
  }
  return ret;
}
